var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import './UiFlex.css';
export function UiFlex(_a) {
    var spacing = _a.spacing, direction = _a.direction, props = __rest(_a, ["spacing", "direction"]);
    direction = direction || 'row';
    spacing = spacing || 0;
    var style = {};
    if (props.position) {
        style.position = props.position;
    }
    if (props.flexWrap) {
        style.flexWrap = props.flexWrap;
    }
    if (props.alignItems) {
        style.alignItems = props.alignItems;
    }
    if (props.justifyContent) {
        style.justifyContent = props.justifyContent;
    }
    return (React.createElement("div", { className: clsx('UiFlex', props.fullWidth && 'fullWidth', props.fullHeight && 'fullHeight', props.flexChildren && 'flexChildren', props.overflowAuto && 'overflowAuto', "direction-" + direction, "spacing-" + spacing, props.className), style: style, onClick: props.onClick }, props.children));
}
